import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';

const StudentPayment = () => {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [generating, setGenerating] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const [addModalOpen, setAddModalOpen] = useState(false);
    const [historyDate, setHistoryDate] = useState('');
    const [historyAmount, setHistoryAmount] = useState('');
    const [addingHistory, setAddingHistory] = useState(false);

    const selectedStudentId = sessionStorage.getItem('selectedStudentId');

    useEffect(() => {
        if (!selectedStudentId) {
            setError("No student ID found in session.");
            setLoading(false);
            return;
        }

        const fetchPayments = async () => {
            try {
                const response = await axios.get(
                    `https://api.admissionsmanipal.com/api/v1/student/${selectedStudentId}/payment`
                );
                setPayments(response.data.data);
            } catch (err) {
                setError("Failed to fetch payment data.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPayments();
    }, [selectedStudentId]);

    const handleGenerateLink = async () => {
        setGenerating(true);
        setSuccessMessage('');
        setError('');

        try {
            await axios.post('https://api.admissionsmanipal.com/api/v1/email-send', {
                id: selectedStudentId,
                amount: amount.toString(),
            });

            setSuccessMessage('Payment link sent to student email.');
            setModalOpen(false);
        } catch (err) {
            console.error(err);
            setError('Failed to generate payment link or send email.');
        } finally {
            setGenerating(false);
            setAmount('');
        }
    };

    const handleAddPaymentHistory = async () => {
        setAddingHistory(true);
        setSuccessMessage('');
        setError('');

        try {
            await axios.post(`https://api.admissionsmanipal.com/api/v1/student/${selectedStudentId}/payment`, {
                date: historyDate,
                amount: historyAmount.toString(),
            });

            setSuccessMessage("Payment history added successfully.");
            setAddModalOpen(false);
            setHistoryAmount('');
            setHistoryDate('');

            const response = await axios.get(
                `https://api.admissionsmanipal.com/api/v1/student/${selectedStudentId}/payment`
            );
            setPayments(response.data.data);
        } catch (err) {
            console.error(err);
            setError("Failed to add payment history.");
        } finally {
            setAddingHistory(false);
        }
    };

    const columns = [
        {
            name: 'Payment ID',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
        },
        {
            name: 'Amount',
            selector: row => `₹${row.amount.toLocaleString()}`,
            sortable: true,
        },
    ];

    return (
        <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
       

            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                <button
                    onClick={() => setModalOpen(true)}
                    style={{
                        padding: '0.5rem 1rem',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Generate Payment Link
                </button>
                <button
                    onClick={() => setAddModalOpen(true)}
                    style={{
                        padding: '0.5rem 1rem',
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Add Payment History
                </button>
            </div>

            {loading && <p style={{ color: '#6c757d' }}>Loading...</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}

            {!loading && !error && (
                <div>
                    <DataTable
                        columns={columns}
                        data={payments}
                        pagination
                        paginationPerPage={5}
                        highlightOnHover
                        striped
                        responsive
                    />
                </div>
            )}

            {/* Modal Styling */}
            {(modalOpen || addModalOpen) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '2rem',
                        borderRadius: '8px',
                        width: '90%',
                        maxWidth: '400px',
                        position: 'relative',
                    }}>
                        <button
                            onClick={() => {
                                setModalOpen(false);
                                setAddModalOpen(false);
                            }}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                            }}
                        >
                            &times;
                        </button>

                        {modalOpen && (
                            <>
                                <h2>Generate Payment Link</h2>
                                <label htmlFor="amount" style={{ display: 'block', margin: '10px 0 5px' }}>Amount (INR)</label>
                                <input
                                    id="amount"
                                    type="number"
                                    placeholder="Enter amount"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        marginBottom: '1rem',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                    }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                                    <button
                                        onClick={() => setModalOpen(false)}
                                        style={{
                                            padding: '0.5rem 1rem',
                                            backgroundColor: '#6c757d',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleGenerateLink}
                                        disabled={generating || !amount}
                                        style={{
                                            padding: '0.5rem 1rem',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            opacity: generating || !amount ? 0.6 : 1
                                        }}
                                    >
                                        {generating ? 'Sending...' : 'Send Link'}
                                    </button>
                                </div>
                            </>
                        )}

                        {addModalOpen && (
                            <>
                                <h2>Add Payment History</h2>
                                <label htmlFor="history-date" style={{ display: 'block', margin: '10px 0 5px' }}>Date</label>
                                <input
                                    id="history-date"
                                    type="date"
                                    value={historyDate}
                                    onChange={(e) => setHistoryDate(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        marginBottom: '1rem',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                    }}
                                />
                                <label htmlFor="history-amount" style={{ display: 'block', margin: '10px 0 5px' }}>Amount (INR)</label>
                                <input
                                    id="history-amount"
                                    type="number"
                                    placeholder="Enter amount"
                                    value={historyAmount}
                                    onChange={(e) => setHistoryAmount(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        marginBottom: '1rem',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                    }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                                    <button
                                        onClick={() => setAddModalOpen(false)}
                                        style={{
                                            padding: '0.5rem 1rem',
                                            backgroundColor: '#6c757d',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleAddPaymentHistory}
                                        disabled={addingHistory || !historyAmount || !historyDate}
                                        style={{
                                            padding: '0.5rem 1rem',
                                            backgroundColor: '#28a745',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            opacity: addingHistory || !historyAmount || !historyDate ? 0.6 : 1
                                        }}
                                    >
                                        {addingHistory ? 'Saving...' : 'Save History'}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default StudentPayment;
